import { APP_INITIALIZER, ErrorHandler, Provider } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { constants } from '@shared/constants';
import { getEnvironment } from '../app.config';

/* Sentry initializing */
export const initializeSentry = (release: string) => {
  const isLocalhost = location.hostname === 'localhost';

  Sentry.init({
    enabled: !isLocalhost,
    dsn: getEnvironment().production ? constants.SENTRY_PROD_DSN : constants.SENTRY_DSN,
    environment: getEnvironment().name,
    release,
    attachStacktrace: true,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 0.5,
    tracePropagationTargets: ['https://*.rocketkor-nonprod.net', 'https://*.rocketkor.net'],
  });
};

/* Sentry providers configuration */
export const sentryProviders: () => Provider[] = () => {
  return [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => ({}),
      deps: [Sentry.TraceService],
      multi: true,
    },
  ];
};
